import {t} from '@lingui/core/macro';

import {pluralize} from 'shared/lib/format/pluralize';

export const getPausedText = (counter: number) => {
    return pluralize(counter, {
        one: t`Приостановлен`,
        few: t`Приостановлены`,
        many: t`Приостановлено`,
    });
};